// @ts-strict-ignore
// We support the schema addons found here:
// https://www.notion.so/f912fb36f2e6468d87d0b41c0c951528#c6d16c4f444e4f8a9b29d50920f4fce9

const addons = {
  footer: 'addons.Footer',
  info: 'addons.Info',
  usp: 'addons.Usp',
  image: 'addons.Image',
  moreInformationBlock: 'addons.MoreInformationBlock',
  moreInformationCTA: 'addons.MoreInformationCTA',
  phoneNumber: 'addons.PhoneNumber',
}

const getAddonType = (name) => {
  const addonType = addons[name]

  if (!addonType) {
    throw new Error(
      `Expected on following addon names: ${Object.keys(addons).join(', ')}, instead got: ${name}`,
    )
  }

  return addonType
}

export const findAddon = (name, addons) => {
  const addonType = getAddonType(name)

  return addons.find((addon) => addon.type === addonType)
}

export const filterAddons = (name, addons) => {
  const addonType = getAddonType(name)

  return addons.filter((addon) => addon.type === addonType)
}
